import styled, { css } from 'styled-components';
import { BlankBtn } from 'components/Buttons';

interface IWelcomeTitle {
  hasCourse: boolean;
}

export const WelcomeTitleContainer = styled.div<IWelcomeTitle>`
  ${({ hasCourse }) => css`
    // grid-template-columns: ${hasCourse ? '40% 60%' : '1fr 1fr'};
    // padding: ${hasCourse ? '0 4%' : '0 10%'};
  `}

  display: flex;
  flex-wrap: wrap;
  margin-top: 62px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  padding: 7px 7px 7px 20px;
  color: var(--color-text);

  @media (max-width: 768px) {
    flex-direction: column;
    margin-top: 0;
    box-shadow: none;
  }

  .title-text {
    width: 70%;
    padding-right: 25px;
    padding-top: 15px;
    padding-bottom: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    .bar {
      margin-top: 40px;
    }

    h1 {
      font-family: 'Inter Bold';
      font-size: 28px;
      margin-bottom: 6px;
    }

    h3 {
      font-family: 'Inter';
      font-weight: 300;
      font-size: var(--font-medium);

      span {
        font-family: 'Signika Bold';
        font-size: var(--font-large);
      }
    }

    h4 {
      font-family: 'Inter Bold';
      font-size: var(--font-large);
      margin-bottom: 7px;
      color: var(--primary-color);
    }

    p {
      font-size: var(--font-medium);
      line-height: 28px;
      color: var(--primary-color);

      span {
        font-family: 'Inter Bold';
        font-size: var(--font-medium);
      }
    }

    @media (max-width: 768px) {
      width: 100%;
      padding-right: 20px;
      margin-bottom: 40px;
    }
  }

  > button {
    width: 30%;
    align-self: center;
  }
`;

export const LastWatchedContainer = styled.div`
  background: linear-gradient(123.55deg, #d82e88 0.89%, #40909f 100%);
  border-radius: 15px;
  position: relative;
  width: 30%;
  padding: 20px;

  @media (max-width: 768px) {
    width: 100%;
    margin: 0;
  }

  .img-woman-period {
    transform: scaleX(-1);
  }

  .progress-container {
    position: absolute;

    .container {
      position: absolute;
      left: -110px;
      top: -2px;
    }

    .sm {
      display: none;

      @media (max-width: 768px) {
        display: initial;
        position: absolute;
        top: 35px;
        left: 110px;
      }
    }

    .xl {
      @media (max-width: 768px) {
        display: none;
      }
    }

    img {
      position: absolute;
      height: 270px;
      top: -32px;
      left: -30px;
      z-index: 3;

      @media (max-width: 768px) {
        top: 40px;
        left: 46px;
        height: 120px;
      }
    }
  }

  .watched-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    .image-container {
      position: relative;
      cursor: pointer;
      margin-bottom: 20px;
      width: 370px;
      height: 220px;
      max-width: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 12px;
      }

      .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 12px;
      }

      .play-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
        height: 40px;
        margin-bottom: 0;
        object-fit: none;
      }
    }

    .container-btn {
      button {
        background-color: white;
        color: var(--primary-color);
        width: 100%;
        height: 45px;
        border: 1.8px solid var(--primary-color);
        font-size: var(--font-medium);
        gap: 12px;
      }

      @media (max-width: 1250px) {
        button {
          width: 100%;
          font-size: var(--font-small);
        }
      }
    }

    h1 {
      color: var(--secondary-color-light);
      font-size: var(--font-large);
      text-transform: uppercase;

      @media (max-width: 768px) {
        font-size: var(--font-medium);
      }
    }

    h4 {
      font-size: var(--font-medium);
      font-family: 'Inter ExtraBold';
      margin-bottom: -15px;

      @media (max-width: 768px) {
        font-size: var(--font-small);
      }
    }

    p {
      width: 80%;
      color: var(--color-text-card);
      font-size: var(--font-medium);
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;

      @media (max-width: 768px) {
        font-size: var(--font-small);
      }
    }
  }
`;

export const ImagTitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 50px;

  .avatar-container {
    width: 60px;
    height: 60px;
    background-color: var(--primary-color-light);
    border-radius: 12px;
    padding: 10px;
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;

    .avatar-container {
      margin-right: 0;
      margin-bottom: 20px;
    }
  }
`;

export const DashBlankBtn = styled(BlankBtn)`
  font-family: 'Inter Bold';
  text-transform: uppercase;
  font-size: var(--font-normal) !important;

  img {
    width: 15px;
  }
`;
